/**
 * Plan validation schemas.
 *
 * Zod schemas for plan form validation used in PlanDrawer.
 */
import { z } from 'zod'

export const PlanSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(100, 'Name must be at most 100 characters'),
  maxAgents: z
    .number({ message: 'Max agents is required' })
    .int()
    .min(1, 'Max agents must be at least 1')
    .max(10000, 'Max agents must be at most 10,000'),
  maxConcurrentCalls: z
    .number({ message: 'Max concurrent calls is required' })
    .int()
    .min(1, 'Max concurrent calls must be at least 1')
    .max(50000, 'Max concurrent calls must be at most 50,000'),
  features: z.array(z.string()).default([]),
})

export type PlanFormValues = z.infer<typeof PlanSchema>
